<template>
  <scroll-center-dialog v-model="open" :loading="loading" @close="close" @apply="save" :apply-text="'ПЕРЕЙТИ'" :left="false" :title="form_title" :scrolled="false">
    Нажимая кнопку перейти, вы соглашаетесь с передачей ваших персональных данных системе Science-ID и становитесь участником.
    <template v-slot:prepend-actions>
      <v-spacer/>
      <v-btn
          class="apply__btn"
          @click="close"
      >
        <span class="apply__btn_text">
          ОТМЕНА
        </span>
      </v-btn>
    </template>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog"

export default {
  name: "UserScienceIdDialog",
  props: {
    value: Boolean,
  },
  components: {
    ScrollCenterDialog,
  },
  mixins: [FormErrorsMixin],
  data () {
    return {
      open: false,
      loading: false,
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        this.open = this.value
      }
    },
    open: {
      immediate: true,
      handler () {
        this.$emit('input', this.open)
      }
    }
  },
  computed: {
    form_title () {
      return 'science-id'
    },
  },
  methods: {
    save () {
      this.$emit('save')
    },
    close () {
      this.$emit('close')
    },
  },
  created () {
  }
}
</script>

<style scoped lang="scss">
.dialog__fields {
  margin-bottom: 5px;
}

.field_label__text {
  margin-bottom: 10px;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 17px;
  display: flex;
  align-items: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  color: #3254B9;
}

.check__box {
  margin: 0 auto;
  width: 100%;
  color: #313743;
}

.check__box_text {
  padding-left: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: inline-block;
  align-items: center;
  text-align: left;
  color: #313743;
}

.apply__btn {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 136px;
  height: 40px;
  border: 2px solid #3254B9;
  background: #ffffff;
  border-radius: 5px;

  &:hover {
    background-color: #3254B9;

    .apply__btn_text {
      color: #ffffff;
    }
  }
}

.apply__btn_text {
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #3254B9;
}

@media screen and (max-width: 768px) {
  .field_label__text {
    font-size: 12px;
    line-height: 15px;
  }

  .check__box_text {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }
}
</style>
